export enum DisabilityProduct {
    SHORT_TERM_DISABILITY = 'Short-term disability',
    LONG_TERM_DISABILITY = 'Long-term disability'
}
